module.exports = __webpack_public_path__ + "6cdb35d4bfeca12ab90ebeb408dcb6a3.jpg";